import React from 'react';
import { FormInstance } from 'antd/es/form';
import { useRecoilState } from 'recoil';
import { AutoCompleteInput } from 'components/base/AutoComplete';
import { communityAutoCompleteCompanyName } from 'libs/api/community';
import { TInterviewFirmInfo } from 'modules/community';
import { interviewFirmInfoState } from 'modules/community/recoilState';
import { CEmploymentType } from 'constants/community.const';
import { EEmploymentType } from 'enums/community.enum';
import { Form, Input, Select } from 'antd';
import styled from 'styled-components';
import { device } from 'GlobalStyles';

type TAboutCompanyProps = {
  form: FormInstance;
};

const CompanyNameAndEmploymentType = ({ form }: TAboutCompanyProps) => {
  const [interviewFirmInfo, setInterviewFirmInfo] = useRecoilState<TInterviewFirmInfo>(
    interviewFirmInfoState,
  );

  const onEmploymentTypeChange = (e: any) => {
    setInterviewFirmInfo({ ...interviewFirmInfo, employmentType: e });
  };

  return (
    <CompanyNameAndEmploymentTypeWrapper>
      <StyledCompanyNameContainer>
        <Form.Item
          className='form-item community-selector'
          name={'company_name'}
          label={'기업명'}
          rules={[{ required: true }]}
        >
          <AutoCompleteInput
            board={'community'}
            promise={communityAutoCompleteCompanyName}
            form={form}
            name={'company_name'}
          >
            <Input
              onChange={() => {
                form.setFieldsValue({ company_name_id: undefined });
              }}
              autoComplete='off'
              size='large'
              placeholder='회사명을 입력해주세요'
            />
          </AutoCompleteInput>
        </Form.Item>
        <Form.Item className='form-item community-selector' name={'company_name_id'} hidden={true}>
          <Input />
        </Form.Item>
      </StyledCompanyNameContainer>
      <StyledEmploymentTypeContainer>
        <Form.Item
          className='form-item community-selector'
          name={'employment_type'}
          label={'고용형태'}
          rules={[{ required: true }]}
        >
          <Select placeholder='고용형태 선택하기' onChange={(e) => onEmploymentTypeChange(e)}>
            <Select.Option value={EEmploymentType.Newcomer}>
              {CEmploymentType[EEmploymentType.Newcomer]}
            </Select.Option>
            <Select.Option value={EEmploymentType.ExperiencedWorker}>
              {CEmploymentType[EEmploymentType.ExperiencedWorker]}
            </Select.Option>
            <Select.Option value={EEmploymentType.TransitionalTypeIntern}>
              {CEmploymentType[EEmploymentType.TransitionalTypeIntern]}
            </Select.Option>
            <Select.Option value={EEmploymentType.GeneralTypeIntern}>
              {CEmploymentType[EEmploymentType.GeneralTypeIntern]}
            </Select.Option>
          </Select>
        </Form.Item>
      </StyledEmploymentTypeContainer>
    </CompanyNameAndEmploymentTypeWrapper>
  );
};

export default CompanyNameAndEmploymentType;

const CompanyNameAndEmploymentTypeWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 2px;
  @media screen and ${device.sm} {
    flex-direction: column;
  }
`;

const StyledCompanyNameContainer = styled.div`
  width: 49%;
  @media screen and ${device.sm} {
    width: 100%;
  }
`;
const StyledEmploymentTypeContainer = styled.div`
  width: 49%;
  @media screen and ${device.sm} {
    width: 100%;
  }
`;
